<template>
    <div class="content">
        <div class="content-content" v-if="nextStep == 1">
            <div class="action-title-top">选择订单</div>
            <div class="content-top">
                <el-form ref="form" label-position="left" label-width="100px">
                    <el-form-item label="ERP订单号：">
                        <el-input  autocomplete="on" name="Orders_SN"  v-model="Orders_SN" class="el-select-max" clearable></el-input>
                    </el-form-item>
                </el-form>
                <el-button type="primary" @click="onNext()">下一步</el-button>
            </div>
        </div>
        <div class="content-content" v-if="nextStep == 2">
            <div class="action-title-top">选择订单</div>
            <el-descriptions title="订单基本信息" v-if="orders_id">
                <el-descriptions-item label="ERP订单号">{{ ordersDetail.Orders_ERPSN }}</el-descriptions-item>
                <el-descriptions-item label="下单时间">{{ ordersDetail.Orders_AddTime | formatDates }}</el-descriptions-item>
                <el-descriptions-item label="分支机构">{{ ordersDetail.Orders_OfficeCode }}</el-descriptions-item>
                <el-descriptions-item label="业务员">{{ ordersDetail.Orders_OfficeMan }}</el-descriptions-item>
                <el-descriptions-item label="工程名称">{{ ordersDetail.Orders_ProjectName }}</el-descriptions-item>
                <el-descriptions-item label="工程地址">{{ ordersDetail.Orders_ProjectAddress }}</el-descriptions-item>
                <el-descriptions-item label="客户编码">{{ ordersDetail.Orders_CustomerCode }}</el-descriptions-item>
                <el-descriptions-item label="客户名称">
                    {{ ordersDetail.Orders_CustomerName }}
                    <span v-if="ChangeSPCApplyData.Customer_IsESign == 1" class="signature-tips">已注册电子签章</span>
                </el-descriptions-item>
                <el-descriptions-item label="订单总额">
                    <span style="color: red; font-weight: bold">¥{{ ordersDetail.Orders_Amount }}</span>
                </el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="订单基本信息" v-else>
                <el-descriptions-item label="ERP订单号">{{ orderInfo.Orders.Orders_ERPSN }}</el-descriptions-item>
                <el-descriptions-item label="下单时间">{{ orderInfo.Orders.Orders_AddTime | formatDates }}</el-descriptions-item>
                <el-descriptions-item label="分支机构">{{ orderInfo.Orders.Orders_OfficeCode }}</el-descriptions-item>
                <el-descriptions-item label="业务员">{{ orderInfo.Orders.Orders_OfficeMan }}</el-descriptions-item>
                <el-descriptions-item label="工程名称">{{ orderInfo.Orders.Orders_ProjectName }}</el-descriptions-item>
                <el-descriptions-item label="工程地址">{{ orderInfo.Orders.Orders_ProjectAddress }}</el-descriptions-item>
                <el-descriptions-item label="客户编码">{{ orderInfo.Orders.Orders_CustomerCode }}</el-descriptions-item>
                <el-descriptions-item label="客户名称">
                    {{ orderInfo.Orders.Orders_CustomerName }}
                    <span v-if="orderInfo.submitdata.Customer_IsESign == 1" class="signature-tips">已注册电子签章</span>
                </el-descriptions-item>
                <el-descriptions-item label="订单总额">
                    <span style="color: red; font-weight: bold">¥{{ orderInfo.Orders.Orders_Amount }}</span>
                </el-descriptions-item>
            </el-descriptions>
            <div class="action">
                <div class="action-title">退货商品列表</div>
                <div class="action-search">
                    <el-select class="el-select-medium" v-model="params.salegroup" placeholder="请选择销售组">
                        <el-option v-for="item in SaleGroupOption" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                    <el-input class="el-select-medium ml10" v-model="params.lineNumbers" placeholder="请输入行号搜索"></el-input>
                    <el-input class="el-select-medium ml10" v-model="params.goodsName" placeholder="请输入商品名称、商品编码检索"></el-input>
                    <el-button type="primary" class="ml10" @click="chooseSearch()">搜索</el-button>
                </div>
                <el-table :data="ordersDetailList" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                    <el-table-column prop="Goods_SaleGroupName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                    <el-table-column prop="Goods_RowNum" label="行号" align="center" width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Goods_AddNum" label="下达号" align="center" width="80" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="Goods_Product_Code" label="商品编码" align="center" width="100"></el-table-column>
                    <el-table-column prop="Goods_Product_Name" label="商品名称" align="left"></el-table-column>
                    <el-table-column prop="Product_Spc" label="规格" align="center" width="100"></el-table-column>
                    <el-table-column prop="" label="已下架" align="center" width="80">
                        <template v-slot="scope">
                            <span>{{ scope.row.Product_IsInsale == 0 ? '是' : '否' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Goods_Product_SourcePrice" label="单价" align="center" width="100">
                        <template slot-scope="scope">
                            <span class="red">￥{{ getFloat(scope.row.Goods_Product_Price, 4) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Deliver_Amount" label="总数" align="center" width="80"></el-table-column>
                    <el-table-column prop="" label="合计" align="center" width="100">
                        <template v-slot="scope">
                            <span>￥{{ scope.row.Deliver_Amount * scope.row.Goods_Product_SourcePrice }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ReturnQuantity" label="可退货数量" align="center" width="100"></el-table-column>
                    <el-table-column prop="Goods_IsInsale" label="退货单价" align="center" width="100">
                        <template v-slot="scope">
                            <el-input v-model="scope.row.Goods_Product_Price" type="number" @blur="obtainPrice"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Goods_IsInsale" label="退货数量" align="center" width="100">
                        <template v-slot="scope">
                            <el-input v-model="scope.row.Goods_Product_Amount" type="number" @blur="obtainPrice"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="action-footer">
                    <span>
                        商品金额合计：
                        <span style="color: red">¥{{ totalPrice | formatePrice3 }}</span>
                    </span>
                </div>
                <div class="action-footer-btn">
                    <el-button type="primary" @click="goSettlement()">去结算</el-button>
                </div>
            </div>
        </div>
        <div class="content-content" v-if="nextStep == 3">
            <div class="action-title-top">完善合同信息</div>
            <submitSpcOrder :orderInfo="orderInfo" @mountedEnd="submitMountedMethods" :ordersid="orders_id" ref="SubmitSpcOrder" :submitCustomerInfor="submitCustomerInfor" :submitReturnsList="submitReturnsList" :totalPrice="totalPrice"></submitSpcOrder>
            <div class="action-footer-btn">
                <el-button type="primary" @click="nextStep = 2">继续退货</el-button>
                <el-button type="primary" @click="submitContract('save')">保存合同</el-button>
                <el-button type="primary" @click="submitContract('next')">下一步</el-button>
            </div>
        </div>
        <div class="content-content" v-if="nextStep == 4">
            <div class="action-title-top">确认合同信息</div>
            <comfirmSpcOrder :orderInfo="orderInfo" :ordersid="orders_id" ref="comfirmSpcOrder" :submitCustomerInfor="submitCustomerInfor" :submitReturnsList="submitReturnsList" :totalPrice="totalPrice"></comfirmSpcOrder>
            <div class="action-footer-btn">
                <el-button type="primary" @click="nextStep = 3">上一步</el-button>
                <el-button type="primary" @click="submitContract('submit')">提交合同</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import submitSpcOrder from './component/submitSpcOrder.vue';
import comfirmSpcOrder from './component/comfirmSpcOrder.vue';
export default {
    name: 'applyReturn',
    data() {
        return {
            Orders_SN: '',
            orderInfo: {
                Orders: {
                    OrdersDetail: [],
                    Orders_Contract_Email: '',
                    Orders_Contract_Mobile: '',
                    Orders_Contract_Name: '',
                    Orders_CustomerMobile: '',
                    Orders_DeliveryTime: '',
                    Orders_DiscountRate: 0,
                    Orders_PaperContractSN: '',
                    Orders_PayType_ID: 0,
                    Orders_ProjectCity: '',
                    Orders_ProjectCountry: '1',
                    Orders_ProjectCounty: '',
                    Orders_ProjectNote: '',
                    Orders_ProjectState: '',
                    Orders_ProjectType_ID: 0,
                    Orders_ProjectType_Name: '',
                    Orders_ReturnCity: '',
                    Orders_ReturnCountry: '',
                    Orders_ReturnCounty: '',
                    Orders_ReturnState: '',
                    Orders_SN: '',
                    Orders_SPCOrdersID: 0,
                    Orders_SourceType: 0,
                    Orders_Type: '',
                    Orders_WaitStatus: 0,
                    Paytype_Name: null,
                    Orders_AddTime: '',
                    Orders_Amount: 0,
                    Orders_CurOfficeCode: null,
                    Orders_CurOfficeMan: null,
                    Orders_CurOfficeManCode: null,
                    Orders_CustomerCode: '',
                    Orders_CustomerName: '',
                    Orders_DeliveryAddress: '',
                    Orders_ERPSN: '',
                    Orders_ID: 0,
                    Orders_IsDistributeRule: 0,
                    Orders_OfficeCode: '',
                    Orders_OfficeMan: '',
                    Orders_OfficeManCode: '',
                    Orders_OfficeName: null,
                    Orders_ProjectAddress: '',
                    Orders_ProjectName: '',
                    Orders_SPCSN: '',
                    Orders_Time: ''
                },
                submitdata: {
                    Customer_Sub_ID: 0,
                    customer_id: 0,
                    Customer_Code: '',
                    Customer_Name: '',
                    Customer_Mobile: '',
                    Orders_Type: 0,
                    apply_id: 0,
                    SPCOrders_id: 0,
                    orders_copy: 0,
                    erp_sn: '',
                    Orders_SourceCate: 0,
                    Orders_PayType_ID: 0,
                    Orders_PayType_Name: '',
                    Orders_SPCOrdersID: 0,
                    Member_ID: '',
                    customer_type: 0,
                    Customer_RegAddr: '',
                    Customer_IsESign: 0,
                    SaleGroupOption: ''
                },
                CheckInvoice: true,
                OnlyBack: null
            },
            orders_id: '', // 修改的订单
            params: {
                salegroup: '',
                lineNumbers: '',
                goodsName: ''
            },
            totalPrice: 0,
            SaleGroupOption: [],
            ordersDetailList: [],
            ordersDetailAllList: [],
            customersubInfor: '',
            resultInfo: {},
            // 提交信息
            Orders_SourceCate: 1,
            submitCustomerInfor: {},
            submitReturnsList: [],
            nextStep: 1,
            Orders_ERPSN: '',
            ChangeSPCApplyData: {}, //修改信息
            ordersDetail: []
        };
    },
    components: {
        submitSpcOrder,
        comfirmSpcOrder
    },
    created() {
        // 根据传参来判断执行操作
        this.disposequeryID(this.$route.query);
    },
    mounted() {},
    methods: {
        async disposequeryID(params) {
            for (const [key, value] of Object.entries(params)) {
                switch (key) {
                    case 'id':
                        console.log('退货修改');
                        this.orders_id = value;
                        this.changeOrder();
                        break;

                    default:
                        console.log('创建退货');
                }
            }
        },
        // 修改
        async changeOrder() {
            this.nextStep = 2;
            let loadingInstance = this.$loading(); // 显示 loading
            let { data: result } = await this.$newsApi.order.SPCOrders_Edit_Check({ ordersid: this.orders_id });
            this.$closeLoading(loadingInstance); // 关闭 loading
            let ChangeSPCApplyData = result.data;
            this.ChangeSPCApplyData = ChangeSPCApplyData;
            this.Orders_ERPSN = ChangeSPCApplyData.erp_sn;
            this.GetERPOrders();
            this.InitializationERPOrdersDetail();
        },
        async GetERPOrders() {
            let { data: result } = await this.$newsApi.GetERPOrders({ orders_erpsn: this.Orders_ERPSN });
            this.ordersDetail = result.data;
            this.submitCustomerInfor = result.data;
            this.orderInfo = {
                Orders: result.data,
                submitdata: this.ChangeSPCApplyData
            };
        },
        // 修改的购物车
        async InitializationERPOrdersDetail() {
            let loadingInstance = this.$loading(); // 显示 loading
            let { data: result } = await this.$newsApi.order.InitializationERPOrdersDetail({ ordersid: this.orders_id });
            this.$closeLoading(loadingInstance); // 关闭 loading
            if (result.Resultcode == 0) {
                this.ordersDetailAllList = result.data;
                this.ordersDetailList = JSON.parse(JSON.stringify(this.ordersDetailAllList));
                this.SaleGroupOption = this.SaleGroupOption = [...new Set(this.ordersDetailAllList.map((item) => item.Goods_SaleGroupName))];
                if (this.SaleGroupOption.length > 0) {
                    if (this.SaleGroupOption[0] == '') {
                        this.SaleGroupOption.shift();
                    }
                    this.SaleGroupOption.unshift('全部');
                }
                this.allPrice();
            }
        },
        // 提交合同
        async submitContract(e) {
            let json = this.createdObj(e);
            console.log('json', json);
            json = JSON.stringify(json);
            let loadingInstance = this.$loading(); // 显示 loading
            var result = await this.$newsApi.order.SPCOrders_Create({
                json: json,
                SourceType: 'PC',
                erpordersdetails: this.ordersDetailAllList
            });
            this.$closeLoading(loadingInstance); // 关闭 loading
            console.log(result, 'result');
            if (result.data.Resultcode == 0 && e == 'save') {
                this.$message({
                    message: '退货申请保存成功',
                    type: 'success'
                });
                this.resetDataMy();
                setTimeout(() => {
                    this.$router.push('/contractreturnManagement/index?t=' + Date.now());
                }, 1000);
            } else if (result.data.Resultcode == 0 && e == 'next') {
                this.nextStep = 4;
                this.$nextTick(() => {
                    this.$refs.comfirmSpcOrder.precondition(json);
                });
            } else if (result.data.Resultcode == 0 && e == 'submit') {
                this.$message({
                    message: '退货申请提交成功',
                    type: 'success'
                });
                this.resetDataMy();
                setTimeout(() => {
                    this.$router.push('/contractreturnManagement/index?t=' + Date.now());
                }, 500);
            }else if (result.data.Resultinfo) {
                this.$alert(result.data.Resultinfo, '提示', {
                    confirmButtonText: '确定',
                    type: 'warning'
                }).then(() => {
                    return;
                });
            }
        },
        // 保存合同
        saveContract() {
            console.log('saveContract');
        },
        async onNext() {
            if (this.Orders_SN == '') {
                this.$message({
                    message: 'ERP订单号不能为空',
                    type: 'warning'
                });
                return;
            }
            let loadingInstance = this.$loading(); // 显示 loading
            let ERPres = await this.$newsApi.getERPOrdersByERPSN({ Orders_ERPSN: this.Orders_SN });
            this.$closeLoading(loadingInstance); // 关闭 loading
            let res = {};
            if (ERPres.data.Resultcode == 0) {
                res.data = ERPres.data.data;
                this.nextStep = 2;
                this.orderInfo = res.data;
                this.ordersDetailList = res.data.Orders.OrdersDetail;
                this.ordersDetailAllList = res.data.Orders.OrdersDetail;
                this.SaleGroupOption = res.data.submitdata.SaleGroupOption.split('|');
                if (this.SaleGroupOption.length > 0) {
                    if (this.SaleGroupOption[0] == '') {
                        this.SaleGroupOption.shift();
                    }
                    this.SaleGroupOption.unshift('全部');
                }
                this.allPrice();
            }
        },
        // 去结算
        goSettlement() {
            let totalPrice = 0;
            this.ordersDetailAllList.forEach((item, index) => {
                totalPrice += Number((item.Goods_Product_Price * item.Goods_Product_Amount).toFixed(4));
            });
            totalPrice = Number(totalPrice.toFixed(4));
            // if (totalPrice == 0) {
            //     this.$message({
            //         message: '请选择要退货的商品',
            //         type: 'warning'
            //     });
            //     return;
            // }
            let customerInfor = {};
            if (this.orders_id) {
                customerInfor = this.submitCustomerInfor;
                customerInfor.Customer_ID = this.submitCustomerInfor.customer_id;
                customerInfor.back_amount = totalPrice;
                customerInfor.Customer_Type = this.submitCustomerInfor.customer_type;
                customerInfor.Customer_Code = this.ordersDetail.Orders_CustomerCode;
                customerInfor.Person_Name = this.ordersDetail.Orders_CustomerName;
                customerInfor.Person_Mobile = this.ordersDetail.Orders_CustomerMobile;
            } else {
                customerInfor = this.orderInfo.submitdata;
                customerInfor.Customer_ID = this.orderInfo.submitdata.customer_id;
                customerInfor.back_amount = totalPrice;
                customerInfor.Customer_Type = this.orderInfo.submitdata.customer_type;
                customerInfor.Customer_Code = this.orderInfo.Orders.Orders_CustomerCode;
                customerInfor.Person_Name = this.orderInfo.Orders.Orders_CustomerName;
                customerInfor.Person_Mobile = this.orderInfo.Orders.Orders_CustomerMobile;
            }

            if (customerInfor.Customer_Sub_ID != 0) {
                let customersubInfor = {};
                customersubInfor.Customer_Sub_ID = customerInfor.Customer_Sub_ID;
                this.customersubInfor = customersubInfor;
            } else {
                this.customersubInfor = '';
            }
            this.submitCustomerInfor = customerInfor;
            this.submitReturnsList = this.ordersDetailAllList;
            this.nextStep = 3;
        },
        //搜索
        chooseSearch() {
            this.ordersDetailList = this.ordersDetailAllList.filter((item) => {
                // 销售组
                const matchSaleGroup = !this.params.salegroup || this.params.salegroup === '全部' || item.Goods_SaleGroupName === this.params.salegroup;
                // 行号
                const matchLine = !this.params.lineNumbers || (item.Goods_RowNum && item.Goods_RowNum.indexOf(this.params.lineNumbers) !== -1);
                // 商品名/编码
                const matchGoods = !this.params.goodsName || (item.Goods_Product_Code && item.Goods_Product_Code.indexOf(this.params.goodsName) !== -1) || (item.Goods_Product_Name && item.Goods_Product_Name.indexOf(this.params.goodsName) !== -1);
                return matchSaleGroup && matchLine && matchGoods;
            });
            this.allPrice();
        },
        //获取总价
        allPrice() {
            this.totalPrice = 0;
            this.ordersDetailList.forEach((item, index) => {
                this.totalPrice += Number((item.Goods_Product_Price * item.Goods_Product_Amount).toFixed(2));
            });
            this.totalPrice = Number(this.totalPrice.toFixed(2));
        },
        // 修改单价数量时
        obtainPrice() {
            let obj = {};
            let all = [];
            this.ordersDetailList.forEach((item, index) => {
                obj = item;
                if (item.Goods_Product_Amount < 0 || item.Goods_Product_Amount % 1 != 0) {
                    obj.Goods_Product_Amount = 0;
                } else if (item.ReturnQuantity < item.Goods_Product_Amount) {
                    obj.Goods_Product_Amount = item.ReturnQuantity;
                    this.$message({
                        message: '超过了最大发货数量' + item.ReturnQuantity,
                        type: 'warning'
                    });
                } else if (item.Goods_Product_SourcePrice < item.Goods_Product_Price) {
                    obj.Goods_Product_Price = item.Goods_Product_SourcePrice;
                    this.$message({
                        message: '退货单价不可大于单价',
                        type: 'warning'
                    });
                }
                all.push(obj);
            });
            this.ordersDetailList = all;
            this.allPrice();
            this.modifyAll();
        },
        // 展示数组列表修改时改变全部数组
        modifyAll() {
            let obj = {};
            let all = [];
            this.ordersDetailAllList.forEach((item, index) => {
                obj = item;
                this.ordersDetailList.forEach((iten, indexs) => {
                    if (item.Goods_RowNum == iten.Goods_RowNum && item.Goods_AddNum == iten.Goods_AddNum) {
                        obj.Goods_Product_Amount = iten.Goods_Product_Amount;
                        obj.Goods_Product_Price = iten.Goods_Product_Price;
                    }
                });
                all.push(obj);
            });
            this.ordersDetailAllList = all;
        },
        // 序列化对象
        createdObj(e) {
            let orderInfo = this.orderInfo;
            let spcOrderinfo = {};
            if (e == 'submit') {
                spcOrderinfo = this.$refs.comfirmSpcOrder.getFormParams();
            } else {
                spcOrderinfo = this.$refs.SubmitSpcOrder.getFormParams();
            }
            var obj = {};
            obj.orders_id = this.orders_id || -1;
            obj.Orders_type = this.Orders_Type || 0;
            obj.Orders_SourceCate = this.Orders_SourceCate || 1;
            obj.orders_copy = '';
            obj.SPCOrders_id = 0;

            obj.apply_id = this.apply_id || '';
            obj.orders_target = e == 'save' ? '' : 1; //默认空为保存，1为下一步
            obj.isconfirm = e == 'submit' ? 1 : ''; //默认空为保存，1为提交
            obj.cartgoods = 0;
            obj.Orders_Payway_ID = 6;
            obj.Orders_Payway_Type = 0;

            obj.Orders_BuyerID = this.submitCustomerInfor.Member_ID; //会员ID
            obj.member_id = this.submitCustomerInfor.Member_ID; //会员ID
            obj.customer_id = this.submitCustomerInfor.Customer_ID; //客户ID
            obj.Customer_Sub_ID = this.submitCustomerInfor.Customer_Sub_ID || ''; //二级客户ID
            obj.Customer_Name = this.submitCustomerInfor.Customer_Name; //客户名称
            obj.Customer_Mobile = this.submitCustomerInfor.Customer_Mobile || ''; //客户手机
            obj.Orders_PayType_ID = this.submitCustomerInfor.Orders_PayType_ID; //付款方式ID
            obj.paytype_name = this.submitCustomerInfor.Orders_PayType_Name || this.submitCustomerInfor.value; //付款方式名称

            if (this.submitCustomerInfor.customer_type == 1) {
                obj.Customer_Name = this.submitCustomerInfor.Person_Name;
                obj.Customer_Mobile = this.submitCustomerInfor.Person_Mobile;
            }
            console.log(this.ordersDetail);
            if (this.orders_id) {
                obj.customer_id = this.ChangeSPCApplyData.Customer_ID; //客户ID
                obj.Customer_Name = this.ChangeSPCApplyData.Customer_Name; //客户名称
                obj.member_id = this.ChangeSPCApplyData.Member_ID; //会员ID
                obj.Orders_BuyerID = this.ChangeSPCApplyData.Member_ID; //会员ID
                obj.Customer_Sub_ID = this.ChangeSPCApplyData.Customer_Sub_ID || ''; //二级客户ID
                obj.Customer_Mobile = this.ChangeSPCApplyData.Customer_Mobile || ''; //客户手机
                obj.Orders_PayType_ID = this.ChangeSPCApplyData.Orders_PayType_ID; //付款方式ID
                obj.customer_project_name = this.ordersDetail.Orders_ProjectName;
                obj.Customer_Project_Name = this.ordersDetail.Orders_ProjectName;
                obj.Customer_Project_Name_before = this.ordersDetail.Orders_ProjectName;
                obj.Orders_ProjectType_ID = this.ordersDetail.Orders_ProjectType_ID; //项目类型ID
                obj.erp_sn = this.ordersDetail.Orders_ERPSN; // erp订单号
                obj.Orders_SPCOrdersID = this.ordersDetail.Orders_SPCOrdersID; //退货单id
                obj.Orders_SourceOfficeManCode = this.ordersDetail.Orders_OfficeManCode;
                obj.Orders_SourceOfficeManName = this.ordersDetail.Orders_OfficeMan;
                obj.Orders_SourceOrdersAmount = this.ordersDetail.Orders_Amount;
                obj.ERPOrders_PaperContractSN = this.ordersDetail.Orders_PaperContractSN;
                if (this.ordersDetail.Orders_ProjectCounty) {
                    obj.Orders_ProjectAddress = this.ordersDetail.Orders_ProjectAddress;
                }
            } else {
                obj.customer_project_name = orderInfo.Orders.Orders_ProjectName;
                obj.Customer_Project_Name = orderInfo.Orders.Orders_ProjectName;
                obj.Customer_Project_Name_before = orderInfo.Orders.Orders_ProjectName;
                obj.Orders_ProjectType_ID = orderInfo.Orders.Orders_ProjectType_ID; //项目类型ID
                obj.erp_sn = orderInfo.Orders.Orders_ERPSN; // erp订单号
                obj.Orders_SPCOrdersID = orderInfo.Orders.Orders_SPCOrdersID; //退货单id
                obj.Orders_SourceOfficeManCode = orderInfo.Orders.Orders_OfficeManCode;
                obj.Orders_SourceOfficeManName = orderInfo.Orders.Orders_OfficeMan;
                obj.Orders_SourceOrdersAmount = orderInfo.Orders.Orders_Amount;
                obj.ERPOrders_PaperContractSN = orderInfo.Orders.Orders_PaperContractSN;
                if (orderInfo.Orders.Orders_ProjectCounty) {
                    obj.Orders_ProjectAddress = orderInfo.Orders.Orders_ProjectAddress;
                }
            }

            obj.Show_CreditInvoiceStatus = spcOrderinfo.Orders_CreditInvoiceStatus ? 1 : 0; //是否展示了红冲发发票
            obj.Orders_CreditInvoiceStatus = spcOrderinfo.Orders_CreditInvoiceStatus ? 1 : 0; //是否勾选红冲发票
            obj.Customer_Project_Country = '1'; //项目国家
            obj.Customer_Project_State = spcOrderinfo.Customer_Project_State; //项目省份
            obj.Customer_Project_City = spcOrderinfo.Customer_Project_City; //项目市
            obj.Customer_Project_County = spcOrderinfo.Customer_Project_County; //项目区
            obj.Orders_Contract_Name = spcOrderinfo.Orders_Contract_Name; //联系人姓名
            obj.Orders_Contract_Mobile = spcOrderinfo.Orders_Contract_Mobile; //联系人手机
            obj.Orders_Contract_Email = spcOrderinfo.Orders_Contract_Email; //联系人邮箱
            obj.Orders_MsgNotify = 0;
            obj.Orders_MsgNotify1 = 0;
            obj.Orders_Address_ID = ''; //收货地址编号

            obj.Orders_Address_Country = '1'; //收货地址国家
            obj.Orders_Address_State = spcOrderinfo.Orders_Address_State; /// 收货地省份
            obj.Orders_Address_City = spcOrderinfo.Orders_Address_City; //收货地址市
            obj.Orders_Address_County = spcOrderinfo.Orders_Address_County; //收货地址区
            obj.Orders_Address_StreetAddress = spcOrderinfo.Orders_Address_StreetAddress; //配送收货地址
            obj.Orders_Address_Zip = spcOrderinfo.Orders_Address_Zip; //收货地址邮编
            obj.Orders_Address_Mobile = spcOrderinfo.Orders_Address_Mobile; /// 收货人手机
            obj.Orders_Address_Name = spcOrderinfo.Orders_Address_Name; //收货人
            obj.Orders_Address_Phone_Number = spcOrderinfo.Orders_Address_Phone_Number; /// 收货人固话
            obj.AddressType = 'Y'; /// 收货地类型

            obj.order_note = ''; //订单备注
            obj.Customer_Project_Note = ''; //项目备注

            obj.Orders_Delivery_ID = '4'; /// 配送方式ID
            obj.delivery_name = ''; /// 其他配送方式，DeliveryID=2时必填

            obj.Orders_ReturnCommitment = spcOrderinfo.Orders_ReturnCommitment ? 1 : 0; //是否勾选退货承诺

            obj.Orders_PaperContractSN = '';
            obj.Orders_DeliveryTime = spcOrderinfo.Orders_DeliveryTime; /// 交货时间
            obj.Orders_PlanDeliveryDate = ''; /// 期望交货时间
            obj.Orders_IsAllFreight = '1'; /// 整单发货	整型，必填，0：分批发货，1：整单发货
            obj.Orders_IsAllReach = 0; /// 是否一次发货	整型，默认0,0：否，1：是
            obj.Orders_FreightType = '1'; /// 发货方式	整型，默认0;0：即时发货；1:审核后发货
            obj.Orders_IsPayAuditDelivery = 0; //付款审核后自动发货
            obj.Orders_CustomerPartA = ''; //甲方名称
            obj.Orders_OtherAgreement = ''; //合同其他约定
            obj.Customer_Project_Address = ''; //项目地址

            obj.Orders_ProjectType = ''; //1新建项目  2已建项目(升级改造)
            obj.Orders_ProjectNote = ''; //工基建项目说明
            obj.SessionID = '';
            obj.SPCApply_AdderID = spcOrderinfo.SPCApply_AdderID || '';

            obj.cartgoods = 0;
            obj.Orders_ESignStatus = spcOrderinfo.Orders_ESignStatus;
            obj.Orders_ESignName = spcOrderinfo.Orders_ESignName;
            obj.Orders_EsignMobile = spcOrderinfo.Orders_EsignMobile;
            return obj;
        },
        // 修改时赋值
        submitMountedMethods() {
            if (this.orders_id) {
                this.$refs.SubmitSpcOrder.getSPCOrdersDetails(this.orders_id);
            }
        },
        // 提交之前先刷新自己
        resetDataMy() {
            // let time = Date.now();
            // this.$router.push({ path: '/contractreturnManagement/applyReturn', query: { t: time } }); // 跳转之前先刷新自己
            this.$store.dispatch('delView', this.$route);
        }
    }
};
</script>

<style scoped lang="scss">
.content {
    background-color: #fff;
    padding: 0 20px;
}

.content-top {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    background-color: #fff;
    padding-top: 20px;

    button {
        margin-left: 20px;
        margin-bottom: 18px;
    }
}

.content-content {
    padding: 20px 0;
}

.action-title {
    font-size: 16px;
    color: #303133;
    font-weight: bold;
    background-color: #fff;
    padding: 20px 0;
}

.action-title-top {
    padding-bottom: 15px;
    border-bottom: 1px solid #e4e7ed;
    margin-bottom: 15px;
}
/deep/.form-title {
    line-height: 40px;
    background-color: #eeeeee;
    padding-left: 15px;
}
/deep/.el-table {
    color: #000000;
}
/deep/.el-table thead {
    color: #000000;
}
/deep/ .el-descriptions__body {
    color: #000000;
}
/deep/.el-descriptions-item__label:not(.is-bordered-label) {
    color: #000000;
    font-weight: bold;
    font-size: 14px;
}
/deep/.el-form-item__label {
    color: #000000;
    font-weight: bold;
}
/deep/.info .info-item .label {
    font-weight: bold;
}
/deep/.el-radio {
    color: #000000;
}
.action-search {
    margin-bottom: 20px;
}

.ml10 {
    margin-left: 10px;
}

.action-footer {
    display: flex;
    justify-content: flex-end;
    padding: 20px;
}

.action-footer-btn {
    width: 100%;
    text-align: center;
}
.lm-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
    margin-right: 5px;
}
</style>
